import { createFileRoute } from '@tanstack/react-router';
import { DeleteAccountPolicy } from '@amber-ui/core';

export const Route = createFileRoute('/delete-account')({
  component: DeleteAccountPolicy,
});
